import {useEffect, useState} from "react";

export interface CountDownApi {
    remainingSeconds: number;
    restart: () => void
}

let timer: any = null;
export function useCountDown(seconds: number): CountDownApi {
    const [remainingSeconds, setRemainingSeconds] = useState(seconds);

    useEffect(() => {
        startTimer();
        return () => clearInterval(timer);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (remainingSeconds <= 0) {
            clearInterval(timer)
        }
    }, [remainingSeconds])

    const startTimer = () => {
        timer = setInterval(() => {
            setRemainingSeconds((remainingSeconds) => remainingSeconds - 1);
        }, 1000);
    }

    const restart = () => {
        clearInterval(timer);
        setRemainingSeconds(seconds);
        startTimer();
    }

    return {
        remainingSeconds: remainingSeconds,
        restart: restart
    };
}

